export enum SocketMessages {
    NEW_NOTIFICATION = 'NEW_NOTIFICATION',
    NEW_JOB_APPLICATION = 'NEW_JOB_APPLICATION',
    NEW_JOB = 'NEW_JOB',
    UPDATE_JOB = 'UPDATE_JOB',
    SUBSCRIBE = 'SUBSCRIBE',
    UNSUBSCRIBE = 'UNSUBSCRIBE',
    TOOL_CHAT_CREATE = 'TOOL_CHAT_CREATE',
    TOOL_CHAT_CREATE_FAILED = 'TOOL_CHAT_CREATE_FAILED',
    TOOL_CHAT_CREATE_SUCCESS = 'TOOL_CHAT_CREATE_SUCCESS',
    TOOL_CHAT_REPLY = 'TOOL_CHAT_REPLY',
    SEND_CHAT_MESSAGE_SUCCESS = 'SEND_CHAT_MESSAGE_SUCCESS',
    SEND_CHAT_MESSAGE_FAILED = 'SEND_CHAT_MESSAGE_FAILED',
    SEND_CHAT_MESSAGE = 'SEND_CHAT_MESSAGE',
    REQUIREMENT_RECOMMENDATION_LIST = 'REQUIREMENT_RECOMMENDATION_LIST',
}
